import { useState, useEffect } from "react";

/* ═══════════════════════════════════════════════════════════
   LYFY HOMES · Chimney · Stove · Mixer Grinder
   Colors: #0C0C0F #141419 #1E1E28 #2A2A36 #444454
           #888897 #D4D4E0 #FFFFFF #C8102E #E31837 #8B0000
═══════════════════════════════════════════════════════════ */

/* ── CSS ── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Inter:wght@300;400;500;600;700&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
:root{
  --bg:#0C0C0F; --surf:#141419; --card:#1E1E28; --bdr:#2A2A36;
  --m2:#444454; --muted:#888897; --lt:#D4D4E0; --wh:#FFFFFF;
  --red:#C8102E; --rh:#E31837; --rd:#8B0000;
  --rdim:rgba(200,16,46,.11); --rglow:rgba(200,16,46,.06);
  --fD:'Bebas Neue',Impact,sans-serif; --fB:'Inter',system-ui,sans-serif;
}
html{scroll-behavior:smooth}
body{background:var(--bg);color:var(--lt);font-family:var(--fB);-webkit-font-smoothing:antialiased;overflow-x:hidden}
::-webkit-scrollbar{width:4px;height:4px}
::-webkit-scrollbar-track{background:var(--bg)}
::-webkit-scrollbar-thumb{background:var(--bdr)}
::-webkit-scrollbar-thumb:hover{background:var(--red)}
@keyframes fadeUp{from{opacity:0;transform:translateY(18px)}to{opacity:1;transform:translateY(0)}}
@keyframes slideR{from{transform:translateX(100%)}to{transform:translateX(0)}}
@keyframes ticker{from{transform:translateX(0)}to{transform:translateX(-50%)}}
@keyframes pulse{0%,100%{opacity:1}50%{opacity:.38}}
@keyframes fadeIn{from{opacity:0}to{opacity:1}}
.disp{font-family:var(--fD);letter-spacing:.03em;line-height:.94;color:var(--wh)}
.tag-lbl{font-size:9px;font-weight:600;letter-spacing:3px;text-transform:uppercase;color:var(--muted);display:block;margin-bottom:8px}
.body-p{font-size:14px;line-height:1.78;color:var(--muted);font-weight:300}
.btn{display:inline-flex;align-items:center;justify-content:center;gap:7px;font-family:var(--fB);font-size:10px;font-weight:700;letter-spacing:2px;text-transform:uppercase;cursor:pointer;border-radius:1px;transition:all .2s;white-space:nowrap;border:none}
.btn-r{background:var(--red);color:var(--wh);padding:12px 32px}
.btn-r:hover{background:var(--rh)}
.btn-r:active{background:var(--rd)}
.btn-o{background:transparent;color:var(--lt);border:0.5px solid var(--bdr);padding:12px 28px}
.btn-o:hover{border-color:var(--red);color:var(--red)}
.btn-sm{padding:8px 16px;font-size:9px;letter-spacing:1.5px}
.inp{background:var(--card);border:0.5px solid var(--bdr);color:var(--lt);padding:10px 14px;font-family:var(--fB);font-size:13px;outline:none;transition:border .2s;width:100%;border-radius:1px}
.inp:focus{border-color:var(--red)}
.inp::placeholder{color:var(--m2)}
textarea.inp{resize:vertical;min-height:72px}
select.inp option{background:var(--surf)}
.srow{display:flex;gap:14px;overflow-x:auto;padding-bottom:8px}
.srow::-webkit-scrollbar{height:3px}
.srow::-webkit-scrollbar-thumb{background:var(--red)}
.tbl{width:100%;border-collapse:collapse}
.tbl th{background:var(--card);padding:10px 13px;text-align:left;font-size:9px;letter-spacing:2px;text-transform:uppercase;color:var(--muted);border-bottom:0.5px solid var(--bdr);font-weight:600}
.tbl td{padding:12px 13px;border-bottom:0.5px solid rgba(42,42,54,.6);font-size:13px;vertical-align:middle}
.tbl tr:hover td{background:var(--rglow)}
.anav{padding:11px 20px;cursor:pointer;transition:all .2s;display:flex;align-items:center;gap:10px;font-size:12px;color:var(--muted);border-left:2px solid transparent}
.anav:hover{background:var(--rdim);color:var(--lt)}
.anav.act{background:var(--rdim);color:var(--red);border-left-color:var(--red)}
.moverlay{position:fixed;inset:0;background:rgba(12,12,15,.88);z-index:999;display:flex;align-items:center;justify-content:center;padding:16px;animation:fadeIn .2s ease}
.mbox{background:var(--surf);border:0.5px solid var(--bdr);padding:28px;width:100%;max-width:620px;max-height:92vh;overflow-y:auto;border-radius:1px}
.seam{display:grid;gap:0.5px;background:var(--bdr)}
.seam-c{background:var(--bg);transition:background .25s}
.seam-c:hover{background:var(--card)}
.hr{height:0.5px;background:var(--bdr);width:100%}
.toast{position:fixed;bottom:26px;right:26px;background:var(--red);color:var(--wh);padding:12px 20px;font-size:12px;font-weight:700;letter-spacing:.8px;z-index:9999;animation:fadeUp .25s ease;border-radius:1px;pointer-events:none}
.vpill{border:0.5px solid var(--bdr);background:var(--card);color:var(--muted);padding:7px 14px;font-size:11px;font-weight:500;cursor:pointer;transition:all .2s;border-radius:1px;font-family:var(--fB);white-space:nowrap}
.vpill:hover{border-color:var(--red);color:var(--lt)}
.vpill.active{border-color:var(--red);background:var(--rdim);color:var(--wh);font-weight:600}
.vpill.oos{opacity:.35;cursor:not-allowed}
.spec-row{display:flex;justify-content:space-between;padding:10px 0;border-bottom:0.5px solid var(--bdr);font-size:13px}
.spec-row:last-child{border-bottom:none}
`;

/* ── DATA ── */
const PRODUCTS = [
  /* CHIMNEYS */
  { id:"CH-01", name:"ProAir Filterless Wall Chimney", cat:"Chimney", emoji:"💨",
    tagline:"Auto-clean · Filterless · Baffle filter · Touch/Gesture/Push options",
    pop:true, flash:false, rating:4.6, rev:218,
    about:"The ProAir Filterless Wall Chimney uses advanced auto-clean tech to collect oil and grease automatically, keeping your kitchen smoke-free with zero maintenance hassle. Perfect for Indian cooking.",
    features:["Filterless auto-clean technology","Baffle filter — 5-year warranty","Touch, Gesture & Push-button variants","Built-in thermal auto-clean cycle","1200 m³/hr max suction","LED task lighting"],
    specKeys:[["Suction","suction"],["Size","size"],["Control","control"],["Motor","motor"],["Noise","noise"],["Colour","colour"]],
    variants:[
      {vid:"CH-01-60T", label:"60 cm · Touch",   price:8990,  mrp:15990, disc:44, suction:"1000 m³/hr", size:"60 cm", control:"Touch",       motor:"200W", noise:"58 dB", colour:"Black Steel", stock:14},
      {vid:"CH-01-90T", label:"90 cm · Touch",   price:11490, mrp:19990, disc:43, suction:"1200 m³/hr", size:"90 cm", control:"Touch",       motor:"200W", noise:"58 dB", colour:"Black Steel", stock:8 },
      {vid:"CH-01-60G", label:"60 cm · Gesture", price:12990, mrp:21990, disc:41, suction:"1000 m³/hr", size:"60 cm", control:"Gesture",     motor:"250W", noise:"56 dB", colour:"Black Glass", stock:6 },
      {vid:"CH-01-90G", label:"90 cm · Gesture", price:15490, mrp:25990, disc:40, suction:"1200 m³/hr", size:"90 cm", control:"Gesture",     motor:"250W", noise:"56 dB", colour:"Black Glass", stock:4 },
      {vid:"CH-01-60P", label:"60 cm · Push",    price:6990,  mrp:11990, disc:42, suction:"1000 m³/hr", size:"60 cm", control:"Push-button", motor:"200W", noise:"60 dB", colour:"Black Steel", stock:20},
    ]},
  { id:"CH-02", name:"SlimLine Island Chimney", cat:"Chimney", emoji:"🔲",
    tagline:"Island mount · 360° suction · Bluetooth speaker · Motion sensor",
    pop:true, flash:true, rating:4.8, rev:134,
    about:"The SlimLine Island Chimney is the centerpiece of open kitchens. 360° suction captures smoke from all sides while its minimal design makes a bold architectural statement above your cooking island.",
    features:["360° all-around suction","Aluminium mesh + activated carbon","Motion sensor on/off","Integrated LED lighting","Bluetooth speaker built-in","5-speed inverter motor","5-year motor warranty"],
    specKeys:[["Suction","suction"],["Size","size"],["Control","control"],["Motor","motor"],["Noise","noise"],["Colour","colour"]],
    variants:[
      {vid:"CH-02-90S",  label:"90 cm · Silver",  price:28990, mrp:45990, disc:37, suction:"1400 m³/hr", size:"90 cm",  control:"Motion+Touch", motor:"300W", noise:"52 dB", colour:"Brushed Silver", stock:5},
      {vid:"CH-02-120S", label:"120 cm · Silver", price:36990, mrp:58990, disc:37, suction:"1600 m³/hr", size:"120 cm", control:"Motion+Touch", motor:"300W", noise:"52 dB", colour:"Brushed Silver", stock:3},
      {vid:"CH-02-90B",  label:"90 cm · Black",   price:29990, mrp:47990, disc:38, suction:"1400 m³/hr", size:"90 cm",  control:"Motion+Touch", motor:"300W", noise:"52 dB", colour:"Matte Black",    stock:7},
      {vid:"CH-02-120B", label:"120 cm · Black",  price:37990, mrp:59990, disc:37, suction:"1600 m³/hr", size:"120 cm", control:"Motion+Touch", motor:"300W", noise:"52 dB", colour:"Matte Black",    stock:2},
    ]},
  { id:"CH-03", name:"BuiltIn Recirculation Chimney", cat:"Chimney", emoji:"🪟",
    tagline:"No duct needed · Carbon filter · Under-cabinet · Apartments",
    pop:false, flash:false, rating:4.3, rev:96,
    about:"Perfect for apartments where ducting is impossible. Purifies air through activated carbon and returns clean air to your kitchen — no external duct, no drilling through walls.",
    features:["Ductless / recirculation mode","Activated carbon filters included","Concealed under-cabinet mount","LED lighting strip","2-speed motor","Easy filter replacement","2-year warranty"],
    specKeys:[["Suction","suction"],["Size","size"],["Control","control"],["Motor","motor"],["Noise","noise"],["Colour","colour"]],
    variants:[
      {vid:"CH-03-60",  label:"60 cm Standard", price:5490, mrp:9490,  disc:42, suction:"600 m³/hr", size:"60 cm", control:"Push-button", motor:"150W", noise:"62 dB", colour:"White Steel", stock:18},
      {vid:"CH-03-90",  label:"90 cm Standard", price:6990, mrp:11990, disc:42, suction:"750 m³/hr", size:"90 cm", control:"Push-button", motor:"150W", noise:"62 dB", colour:"White Steel", stock:12},
      {vid:"CH-03-60S", label:"60 cm Slim",     price:7490, mrp:12990, disc:42, suction:"700 m³/hr", size:"60 cm", control:"Touch",       motor:"180W", noise:"59 dB", colour:"Black Steel", stock:9 },
    ]},
  /* STOVES */
  { id:"ST-01", name:"FlameKing Toughened Glass Hob", cat:"Stove", emoji:"🔥",
    tagline:"8mm toughened glass · Italian brass burners · Auto-ignition",
    pop:true, flash:false, rating:4.7, rev:312,
    about:"The FlameKing Glass Hob combines Italian brass burners with premium 8mm toughened glass for superior heat efficiency and a stunning modern aesthetic. Auto-ignition ensures instant, safe lighting every time.",
    features:["8mm toughened black glass top","Italian brass burners","Knob auto-ignition","LPG + PNG compatible","Spill-proof pan-support grooves","Cast iron pan supports","5-year glass warranty"],
    specKeys:[["Burners","burners"],["Top Material","top"],["Ignition","ignition"],["Output","btus"],["Colour","colour"]],
    variants:[
      {vid:"ST-01-2B",  label:"2 Burner Black",  price:4490, mrp:7990,  disc:44, burners:"2", top:"8mm Toughened Glass", ignition:"Auto",   btus:"2800+2800 kcal/hr",        colour:"Black", stock:24},
      {vid:"ST-01-3B",  label:"3 Burner Black",  price:6490, mrp:11490, disc:44, burners:"3", top:"8mm Toughened Glass", ignition:"Auto",   btus:"4000+2800+2800 kcal/hr",   colour:"Black", stock:16},
      {vid:"ST-01-4B",  label:"4 Burner Black",  price:8990, mrp:15990, disc:44, burners:"4", top:"8mm Toughened Glass", ignition:"Auto",   btus:"4000+2800+2800+2800",       colour:"Black", stock:10},
      {vid:"ST-01-2W",  label:"2 Burner White",  price:4690, mrp:8490,  disc:45, burners:"2", top:"8mm Toughened Glass", ignition:"Auto",   btus:"2800+2800 kcal/hr",        colour:"White", stock:8 },
      {vid:"ST-01-3W",  label:"3 Burner White",  price:6690, mrp:11990, disc:44, burners:"3", top:"8mm Toughened Glass", ignition:"Auto",   btus:"4000+2800+2800 kcal/hr",   colour:"White", stock:6 },
    ]},
  { id:"ST-02", name:"CastMaster Stainless Steel Hob", cat:"Stove", emoji:"⚙️",
    tagline:"SS 304 top · High-BTU brass burners · Heavy-duty cast iron",
    pop:false, flash:true, rating:4.5, rev:187,
    about:"Built for heavy-duty Indian cooking, the CastMaster SS Hob features 304-grade stainless steel with high-BTU burners and cast iron pan supports that handle your largest pots with ease.",
    features:["304 stainless steel top","Cast iron heavy-duty pan supports","High-BTU brass burners","Sealed burner design — easy cleaning","LPG + PNG compatible","Auto or Manual ignition options","3-year warranty"],
    specKeys:[["Burners","burners"],["Top Material","top"],["Ignition","ignition"],["Output","btus"],["Colour","colour"]],
    variants:[
      {vid:"ST-02-2M", label:"2 Burner Manual", price:3290, mrp:5990,  disc:45, burners:"2", top:"SS 304", ignition:"Manual", btus:"3500+3500 kcal/hr",       colour:"Steel Silver", stock:30},
      {vid:"ST-02-3M", label:"3 Burner Manual", price:4890, mrp:8990,  disc:46, burners:"3", top:"SS 304", ignition:"Manual", btus:"4500+3500+3500 kcal/hr",  colour:"Steel Silver", stock:18},
      {vid:"ST-02-3A", label:"3 Burner Auto",   price:5690, mrp:9990,  disc:43, burners:"3", top:"SS 304", ignition:"Auto",   btus:"4500+3500+3500 kcal/hr",  colour:"Steel Silver", stock:12},
      {vid:"ST-02-4M", label:"4 Burner Manual", price:6490, mrp:11490, disc:44, burners:"4", top:"SS 304", ignition:"Manual", btus:"4500+3500+3500+3500",      colour:"Steel Silver", stock:8 },
      {vid:"ST-02-4A", label:"4 Burner Auto",   price:7290, mrp:12990, disc:44, burners:"4", top:"SS 304", ignition:"Auto",   btus:"4500+3500+3500+3500",      colour:"Steel Silver", stock:6 },
    ]},
  { id:"ST-03", name:"TurboFlame Built-in Hob", cat:"Stove", emoji:"🟫",
    tagline:"Built-in flush-fit · 5 burners · 5kW wok burner · Sabaf valves",
    pop:true, flash:false, rating:4.8, rev:89,
    about:"Engineered for modular kitchens, the TurboFlame Built-in Hob features a powerful 5kW central wok burner and Sabaf safety valves — covering every Indian cooking technique from tadka to slow simmer.",
    features:["5kW central wok burner","4 auxiliary burners","Sabaf Italian safety valves","Gas failure auto-cut","Triple-ring power burner","Flush built-in design","12mm ultra-thick glass option"],
    specKeys:[["Burners","burners"],["Top Material","top"],["Ignition","ignition"],["Output","btus"],["Colour","colour"]],
    variants:[
      {vid:"ST-03-5G", label:"5 Burner Glass", price:18990, mrp:31990, disc:41, burners:"5", top:"12mm Toughened Glass", ignition:"Auto", btus:"5000+4000+2800+2800+1500", colour:"Black", stock:7},
      {vid:"ST-03-5S", label:"5 Burner SS",    price:16990, mrp:28990, disc:41, burners:"5", top:"SS 304",               ignition:"Auto", btus:"5000+4000+2800+2800+1500", colour:"Steel", stock:5},
      {vid:"ST-03-4G", label:"4 Burner Glass", price:15490, mrp:26990, disc:43, burners:"4", top:"12mm Toughened Glass", ignition:"Auto", btus:"5000+2800+2800+1500",       colour:"Black", stock:9},
      {vid:"ST-03-4S", label:"4 Burner SS",    price:13990, mrp:24990, disc:44, burners:"4", top:"SS 304",               ignition:"Auto", btus:"5000+2800+2800+1500",       colour:"Steel", stock:6},
    ]},
  /* MIXER GRINDERS */
  { id:"MG-01", name:"TurboMix Pro 750W", cat:"Mixer Grinder", emoji:"🥤",
    tagline:"750W copper motor · 3 or 4 jars · Tri-tip blades · 5-year warranty",
    pop:true, flash:false, rating:4.6, rev:428,
    about:"Our most popular mixer grinder — a 750W copper-wound motor with tri-tip stainless steel blades and a 5-year motor warranty. Handles everything from smooth chutneys to tough dry spice grinding.",
    features:["750W copper-wound motor","5-year motor warranty","Tri-tip hardened SS blades","3-speed + pulse control","Overload thermal protection","Anti-skid rubber feet","ISI marked"],
    specKeys:[["Motor","watt"],["Jars","jars"],["Blades","blade"],["Speeds","speed"],["Colour","colour"]],
    variants:[
      {vid:"MG-01-3W", label:"3 Jars · White", price:2890, mrp:4990, disc:42, watt:"750W", jars:"3 (1.5L + 1L + 0.4L)", blade:"Tri-tip SS", speed:"3 + Pulse", colour:"White",       stock:36},
      {vid:"MG-01-3B", label:"3 Jars · Black", price:2990, mrp:5190, disc:42, watt:"750W", jars:"3 (1.5L + 1L + 0.4L)", blade:"Tri-tip SS", speed:"3 + Pulse", colour:"Matte Black", stock:28},
      {vid:"MG-01-3R", label:"3 Jars · Red",   price:3090, mrp:5390, disc:43, watt:"750W", jars:"3 (1.5L + 1L + 0.4L)", blade:"Tri-tip SS", speed:"3 + Pulse", colour:"LYFY Red",    stock:20},
      {vid:"MG-01-4W", label:"4 Jars · White", price:3490, mrp:5990, disc:42, watt:"750W", jars:"4 (1.5L+1L+0.4L+0.3L)", blade:"Tri-tip SS", speed:"3 + Pulse", colour:"White",     stock:14},
      {vid:"MG-01-4B", label:"4 Jars · Black", price:3590, mrp:6190, disc:42, watt:"750W", jars:"4 (1.5L+1L+0.4L+0.3L)", blade:"Tri-tip SS", speed:"3 + Pulse", colour:"Matte Black",stock:10},
      {vid:"MG-01-4R", label:"4 Jars · Red",   price:3690, mrp:6390, disc:42, watt:"750W", jars:"4 (1.5L+1L+0.4L+0.3L)", blade:"Tri-tip SS", speed:"3 + Pulse", colour:"LYFY Red",   stock:8 },
    ]},
  { id:"MG-02", name:"PowerGrind 1000W Heavy-Duty", cat:"Mixer Grinder", emoji:"⚡",
    tagline:"1000W · 4 jars · Atta kneading · Dry grain grinding · 10-yr blades",
    pop:true, flash:true, rating:4.7, rev:256,
    about:"Built for large families and dry grain grinding, the PowerGrind 1000W handles atta, sooji, rice flour and tough coconut. Extra-tough hardened SS blades with a 10-year warranty stay sharp for years.",
    features:["1000W heavy-duty motor","Hardened SS blades — 10-year warranty","4 jars including atta-kneading jar","Dry + wet grinding modes","5-speed + pulse","Auto cut-off on overload","Food-safe polycarbonate jars"],
    specKeys:[["Motor","watt"],["Jars","jars"],["Blades","blade"],["Speeds","speed"],["Colour","colour"]],
    variants:[
      {vid:"MG-02-4W", label:"4 Jars · White", price:4490, mrp:7990, disc:44, watt:"1000W", jars:"4 (2L+1.5L+1L+0.5L)", blade:"Hardened SS", speed:"5 + Pulse", colour:"White",        stock:18},
      {vid:"MG-02-4B", label:"4 Jars · Black", price:4590, mrp:8190, disc:44, watt:"1000W", jars:"4 (2L+1.5L+1L+0.5L)", blade:"Hardened SS", speed:"5 + Pulse", colour:"Matte Black",  stock:12},
      {vid:"MG-02-4G", label:"4 Jars · Grey",  price:4690, mrp:8390, disc:44, watt:"1000W", jars:"4 (2L+1.5L+1L+0.5L)", blade:"Hardened SS", speed:"5 + Pulse", colour:"Charcoal Grey", stock:8 },
    ]},
  { id:"MG-03", name:"JMG Juicer Mixer Grinder 3-in-1", cat:"Mixer Grinder", emoji:"🍊",
    tagline:"500W · Juicer + Mixer + Grinder · BPA-free · Pulp collector",
    pop:false, flash:false, rating:4.4, rev:178,
    about:"Three kitchen needs, one appliance. The JMG combines a high-yield centrifugal juicer with a 500W mixer grinder. Fresh juice, ground spices, blended smoothies — all from a single compact unit.",
    features:["3-in-1: Juicer + Mixer + Grinder","500W efficient motor","High-yield centrifugal juicer","Pulp collector jar included","BPA-free food-contact parts","Safety interlock lid","2-year warranty"],
    specKeys:[["Motor","watt"],["Jars","jars"],["Blades","blade"],["Speeds","speed"],["Colour","colour"]],
    variants:[
      {vid:"MG-03-2W", label:"2 Jars · White", price:2490, mrp:4490, disc:45, watt:"500W", jars:"2 + Juicer attachment", blade:"SS", speed:"2 + Pulse", colour:"White", stock:22},
      {vid:"MG-03-2B", label:"2 Jars · Black", price:2590, mrp:4690, disc:45, watt:"500W", jars:"2 + Juicer attachment", blade:"SS", speed:"2 + Pulse", colour:"Black", stock:16},
      {vid:"MG-03-3W", label:"3 Jars · White", price:2890, mrp:5190, disc:44, watt:"500W", jars:"3 + Juicer attachment", blade:"SS", speed:"3 + Pulse", colour:"White", stock:14},
      {vid:"MG-03-3B", label:"3 Jars · Black", price:2990, mrp:5390, disc:44, watt:"500W", jars:"3 + Juicer attachment", blade:"SS", speed:"3 + Pulse", colour:"Black", stock:10},
    ]},
  { id:"MG-04", name:"MiniMix 500W Compact", cat:"Mixer Grinder", emoji:"🫙",
    tagline:"500W · Compact footprint · Low noise · Small kitchen hero",
    pop:false, flash:false, rating:4.3, rev:112,
    about:"Small kitchens deserve great performance. The MiniMix 500W fits on any counter and handles daily grinding, blending and chopping without bulk. A quiet, efficient workhorse for compact spaces.",
    features:["500W efficient compact motor","Low-noise design — 62 dB","2 stainless steel jars","Easy-pour locking lids","Overload protection cut-off","Anti-skid base","2-year warranty"],
    specKeys:[["Motor","watt"],["Jars","jars"],["Blades","blade"],["Speeds","speed"],["Colour","colour"]],
    variants:[
      {vid:"MG-04-W", label:"White",       price:1590, mrp:2990, disc:47, watt:"500W", jars:"2 (1L + 0.4L)", blade:"SS", speed:"2 + Pulse", colour:"White",       stock:30},
      {vid:"MG-04-B", label:"Black",       price:1590, mrp:2990, disc:47, watt:"500W", jars:"2 (1L + 0.4L)", blade:"SS", speed:"2 + Pulse", colour:"Matte Black",  stock:24},
      {vid:"MG-04-R", label:"Red",         price:1690, mrp:3190, disc:47, watt:"500W", jars:"2 (1L + 0.4L)", blade:"SS", speed:"2 + Pulse", colour:"LYFY Red",     stock:18},
      {vid:"MG-04-P", label:"Pearl White", price:1790, mrp:3390, disc:47, watt:"500W", jars:"2 (1L + 0.4L)", blade:"SS", speed:"2 + Pulse", colour:"Pearl White",  stock:12},
    ]},
];

const CATS = [
  {name:"Chimney",      icon:"💨", sub:"Auto-clean · Wall · Island · Built-in",  hero:"Smoke-free kitchens, every single day"},
  {name:"Stove",        icon:"🔥", sub:"Glass Hob · SS Hob · Built-in · 2–5 Burners", hero:"Power and precision on every flame"},
  {name:"Mixer Grinder",icon:"🥤", sub:"500W–1000W · 2–4 Jars · JMG · Compact",  hero:"Ground to perfection, every time"},
];

const HERO = [
  {sub:"Kitchen Suite 2026",  t1:"LYFY HOMES",    t2:"KITCHEN",      body:"Chimneys, stoves and mixer grinders — every product engineered for the modern Indian kitchen, backed by 30 years of trust.", cta:"SHOP ALL",      emoji:"🍳"},
  {sub:"Premium Chimneys",    t1:"SMOKE-FREE",     t2:"KITCHENS",     body:"Auto-clean filterless technology, gesture controls and 1200 m³/hr suction — keeping your kitchen effortlessly fresh.",        cta:"SHOP CHIMNEYS", emoji:"💨"},
  {sub:"Stoves & Hobs",       t1:"EVERY FLAME",    t2:"PERFECTED",    body:"Italian brass burners, 8mm toughened glass tops and high-BTU wok burners built for the intensity of Indian cooking.",          cta:"SHOP STOVES",   emoji:"🔥"},
  {sub:"Mixer Grinders",      t1:"GROUND TO",      t2:"PERFECTION",   body:"750W to 1000W motors, tri-tip blades and up to 4 jars — from smooth chutneys to dry grain grinding.",                        cta:"SHOP MIXERS",   emoji:"🥤"},
];

const INIT_SEO = {
  metaTitle:"LYFY Homes — Chimney, Stove & Mixer Grinder Experts",
  metaDesc:"Shop LYFY Homes for premium kitchen appliances. Expert range of chimneys, gas stoves and mixer grinders with multiple variants for every kitchen and budget.",
  metaKw:"LYFY Homes, chimney india, auto clean chimney, glass hob, gas stove, mixer grinder india",
  ogTitle:"LYFY Homes — Premium Kitchen Appliances",
  ogDesc:"Premium chimneys, stoves and mixer grinders — engineered for Indian kitchens since 1994.",
  ogImg:"https://lyfyhomes.in/og-image.jpg",
  canonical:"https://lyfyhomes.in/",
  robots:"index, follow",
  schema:`{\n  "@context":"https://schema.org",\n  "@type":"Organization",\n  "name":"LYFY Homes",\n  "url":"https://lyfyhomes.in"\n}`,
};

const fmt = n => `\u20B9${Number(n).toLocaleString("en-IN")}`;

/* ── MICRO ── */
function Toast({msg,onClose}){useEffect(()=>{const t=setTimeout(onClose,2600);return()=>clearTimeout(t)},[]);return <div className="toast">{msg}</div>;}
function Stars({r,sz=11}){return <span style={{color:"#C8102E",fontSize:sz,letterSpacing:1}}>{"★".repeat(Math.floor(r))}{"☆".repeat(5-Math.floor(r))}</span>;}
function Logo({size=26}){return <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:size,letterSpacing:3,userSelect:"none",lineHeight:1}}><span style={{color:"#C8102E"}}>LYFY</span><span style={{color:"#FFFFFF"}}> HOMES</span></div>;}

/* ── TICKER ── */
function Ticker(){
  return <div style={{background:"#C8102E",height:26,overflow:"hidden",display:"flex",alignItems:"center"}}>
    <span style={{display:"inline-block",whiteSpace:"nowrap",animation:"ticker 30s linear infinite",fontSize:9,fontWeight:700,letterSpacing:2.5,textTransform:"uppercase",color:"#fff"}}>
      {Array(8).fill("  🚚 FREE SHIPPING ABOVE \u20B9999  \u00B7  \u26A1 FLASH DEALS LIVE  \u00B7  \uD83C\uDFC6 30 YEARS OF TRUST  \u00B7  \uD83D\uDC8E PREMIUM QUALITY  \u00B7  ").join("")}
    </span>
  </div>;
}

/* ═══════════════════════════
   PRODUCT DETAIL PAGE
═══════════════════════════ */
function ProductDetail({product, onBack, onAdd, onWish, wishlist}){
  const [selV, setSelV] = useState(product.variants[0]);
  const wKey = product.id+"_"+selV.vid;
  const inW  = wishlist.includes(wKey);

  const colours = [...new Set(product.variants.map(v=>v.colour).filter(Boolean))];

  return (
    <div style={{padding:"44px 56px 80px",maxWidth:1200,margin:"0 auto"}}>
      {/* breadcrumb */}
      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:36,fontSize:12,color:"#888897"}}>
        <button onClick={onBack} style={{background:"none",border:"none",cursor:"pointer",fontFamily:"'Inter',sans-serif",fontSize:12,color:"#888897",display:"flex",alignItems:"center",gap:5,padding:0,transition:"color .2s"}}
          onMouseEnter={e=>e.currentTarget.style.color="#C8102E"} onMouseLeave={e=>e.currentTarget.style.color="#888897"}>
          \u2190 {product.cat}
        </button>
        <span style={{color:"#2A2A36"}}>/</span>
        <span style={{color:"#D4D4E0"}}>{product.name}</span>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:56,alignItems:"start"}}>
        {/* LEFT — visual */}
        <div>
          <div style={{background:"#141419",border:"0.5px solid #2A2A36",height:420,display:"flex",alignItems:"center",justifyContent:"center",fontSize:130,position:"relative",overflow:"hidden",borderRadius:1}}>
            {selV.stock===0&&<div style={{position:"absolute",inset:0,background:"rgba(12,12,15,.7)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:2}}><span style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:20,letterSpacing:3,color:"#888897"}}>OUT OF STOCK</span></div>}
            {product.flash&&<div style={{position:"absolute",top:0,left:0,background:"#C8102E",color:"#fff",fontSize:9,fontWeight:700,padding:"4px 10px",letterSpacing:1.5,textTransform:"uppercase",zIndex:3}}>⚡ FLASH SALE</div>}
            <div style={{position:"absolute",inset:0,background:"radial-gradient(circle at 50% 50%,rgba(200,16,46,.06) 0%,transparent 65%)"}}/>
            <div style={{position:"absolute",inset:0,backgroundImage:"linear-gradient(rgba(42,42,54,.12) 1px,transparent 1px),linear-gradient(90deg,rgba(42,42,54,.12) 1px,transparent 1px)",backgroundSize:"40px 40px"}}/>
            <span style={{opacity:.65,position:"relative",zIndex:1,filter:"drop-shadow(0 16px 48px rgba(0,0,0,.8))"}}>{product.emoji}</span>
          </div>
          {/* thumb strip */}
          <div style={{display:"flex",gap:8,marginTop:10}}>
            {product.variants.slice(0,6).map(v=>(
              <button key={v.vid} onClick={()=>setSelV(v)}
                style={{width:58,height:58,background:selV.vid===v.vid?"rgba(200,16,46,.12)":"#141419",border:`0.5px solid ${selV.vid===v.vid?"#C8102E":"#2A2A36"}`,cursor:"pointer",fontSize:22,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,borderRadius:1,transition:"all .2s"}}>
                {product.emoji}
              </button>
            ))}
          </div>
        </div>

        {/* RIGHT — info */}
        <div>
          <span className="tag-lbl">{product.cat}</span>
          <h1 className="disp" style={{fontSize:36,marginBottom:8}}>{product.name}</h1>
          <p style={{fontSize:12,color:"#888897",marginBottom:18,fontStyle:"italic",lineHeight:1.5}}>{product.tagline}</p>

          {/* rating */}
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:22,paddingBottom:22,borderBottom:"0.5px solid #2A2A36"}}>
            <Stars r={product.rating} sz={13}/>
            <span style={{fontSize:13,color:"#888897"}}>{product.rating}</span>
            <span style={{color:"#2A2A36"}}>|</span>
            <span style={{fontSize:12,color:"#888897"}}>{product.rev} reviews</span>
          </div>

          {/* price */}
          <div style={{marginBottom:26}}>
            <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:46,color:"#FFFFFF",letterSpacing:.5,lineHeight:1}}>{fmt(selV.price)}</div>
            <div style={{display:"flex",alignItems:"center",gap:10,marginTop:6}}>
              <span style={{fontSize:13,color:"#444454",textDecoration:"line-through"}}>{fmt(selV.mrp)}</span>
              <span style={{background:"#C8102E",color:"#fff",fontSize:9,fontWeight:800,padding:"3px 8px",letterSpacing:.5}}>{selV.disc}% OFF</span>
              <span style={{fontSize:12,color:"#888897"}}>save {fmt(selV.mrp-selV.price)}</span>
            </div>
          </div>

          {/* variants */}
          <div style={{marginBottom:22}}>
            <div style={{fontSize:9,fontWeight:700,letterSpacing:2,textTransform:"uppercase",color:"#888897",marginBottom:10}}>
              Variant — <span style={{color:"#D4D4E0"}}>{selV.label}</span>
            </div>
            <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
              {product.variants.map(v=>(
                <button key={v.vid} onClick={()=>v.stock>0&&setSelV(v)}
                  className={`vpill${selV.vid===v.vid?" active":""}${v.stock===0?" oos":""}`}>
                  {v.label}{v.stock===0&&<span style={{fontSize:8,color:"#444454",marginLeft:4}}>(OOS)</span>}
                </button>
              ))}
            </div>
          </div>

          {/* colour filter */}
          {colours.length>1&&(
            <div style={{marginBottom:22}}>
              <div style={{fontSize:9,fontWeight:700,letterSpacing:2,textTransform:"uppercase",color:"#888897",marginBottom:10}}>
                Colour — <span style={{color:"#D4D4E0"}}>{selV.colour}</span>
              </div>
              <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
                {colours.map(col=>(
                  <button key={col} onClick={()=>{const m=product.variants.find(v=>v.colour===col&&v.stock>0);if(m)setSelV(m);}}
                    style={{padding:"5px 12px",border:`0.5px solid ${selV.colour===col?"#C8102E":"#2A2A36"}`,background:selV.colour===col?"rgba(200,16,46,.11)":"#1E1E28",color:selV.colour===col?"#FFFFFF":"#888897",fontSize:11,cursor:"pointer",borderRadius:1,fontFamily:"'Inter',sans-serif",transition:"all .2s"}}>
                    {col}
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* stock */}
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:22}}>
            <div style={{width:7,height:7,borderRadius:"50%",background:selV.stock>10?"#22A65A":selV.stock>0?"#E6A817":"#C8102E"}}/>
            <span style={{fontSize:12,color:selV.stock>10?"#22A65A":selV.stock>0?"#E6A817":"#C8102E",fontWeight:600}}>
              {selV.stock>10?"In Stock":selV.stock>0?`Only ${selV.stock} left`:"Out of Stock"}
            </span>
          </div>

          {/* CTAs */}
          <div style={{display:"flex",gap:10,marginBottom:26}}>
            <button onClick={()=>selV.stock>0&&onAdd({...product,variantLabel:selV.label,price:selV.price,mrp:selV.mrp})}
              className="btn btn-r" disabled={!selV.stock}
              style={{flex:1,padding:14,fontSize:10,letterSpacing:2.5,opacity:selV.stock?1:.4}}>
              ADD TO BAG
            </button>
            <button onClick={()=>onWish(wKey)}
              style={{width:48,height:48,background:inW?"#C8102E":"#1E1E28",border:`0.5px solid ${inW?"#C8102E":"#2A2A36"}`,cursor:"pointer",fontSize:18,color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",borderRadius:1,transition:"all .2s",flexShrink:0}}>
              {inW?"♥":"♡"}
            </button>
          </div>

          {/* spec table */}
          {product.specKeys.length>0&&(
            <div>
              <div style={{fontSize:9,fontWeight:700,letterSpacing:2.5,textTransform:"uppercase",color:"#888897",marginBottom:12}}>Specs — {selV.label}</div>
              <div style={{background:"#141419",border:"0.5px solid #2A2A36",padding:"4px 20px",borderRadius:1}}>
                {product.specKeys.map(([label,key])=>selV[key]?(
                  <div key={key} className="spec-row">
                    <span style={{color:"#888897"}}>{label}</span>
                    <span style={{color:"#D4D4E0",fontWeight:500}}>{selV[key]}</span>
                  </div>
                ):null)}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* about + features */}
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:20,marginTop:52}}>
        <div style={{background:"#141419",border:"0.5px solid #2A2A36",padding:26,borderRadius:1}}>
          <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:13,letterSpacing:3,color:"#C8102E",textTransform:"uppercase",marginBottom:14}}>About This Product</div>
          <p className="body-p" style={{fontSize:14,lineHeight:1.85}}>{product.about}</p>
        </div>
        <div style={{background:"#141419",border:"0.5px solid #2A2A36",padding:26,borderRadius:1}}>
          <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:13,letterSpacing:3,color:"#C8102E",textTransform:"uppercase",marginBottom:14}}>Key Features</div>
          <ul style={{listStyle:"none",display:"flex",flexDirection:"column",gap:10}}>
            {product.features.map(f=>(
              <li key={f} style={{display:"flex",gap:10,alignItems:"flex-start",fontSize:13,color:"#D4D4E0"}}>
                <span style={{color:"#C8102E",marginTop:1,flexShrink:0}}>—</span>{f}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

/* ═══════════════════════════
   CATEGORY PAGE
═══════════════════════════ */
function CatPage({catName, products, onSelect, onBack}){
  const info = CATS.find(c=>c.name===catName);
  const items = products.filter(p=>p.cat===catName);

  return (
    <div style={{padding:"44px 56px 80px",maxWidth:1440,margin:"0 auto"}}>
      <button onClick={onBack} style={{background:"none",border:"none",cursor:"pointer",fontFamily:"'Inter',sans-serif",fontSize:12,color:"#888897",display:"flex",alignItems:"center",gap:5,padding:0,marginBottom:32,transition:"color .2s"}}
        onMouseEnter={e=>e.currentTarget.style.color="#C8102E"} onMouseLeave={e=>e.currentTarget.style.color="#888897"}>
        \u2190 All Products
      </button>

      {/* hero banner */}
      <div style={{background:"#141419",border:"0.5px solid #2A2A36",padding:"44px 52px",marginBottom:52,display:"flex",alignItems:"center",gap:36,position:"relative",overflow:"hidden",borderRadius:1}}>
        <div style={{position:"absolute",inset:0,background:"radial-gradient(ellipse 60% 100% at 85% 50%,rgba(200,16,46,.055) 0%,transparent 65%)"}}/>
        <div style={{position:"absolute",inset:0,backgroundImage:"linear-gradient(rgba(42,42,54,.1) 1px,transparent 1px),linear-gradient(90deg,rgba(42,42,54,.1) 1px,transparent 1px)",backgroundSize:"48px 48px"}}/>
        <div style={{fontSize:72,position:"relative",zIndex:1}}>{info?.icon}</div>
        <div style={{position:"relative",zIndex:1}}>
          <span className="tag-lbl">{info?.sub}</span>
          <h1 className="disp" style={{fontSize:50,marginBottom:8}}>{catName.toUpperCase()}</h1>
          <p className="body-p">{info?.hero} &nbsp;·&nbsp; {items.length} products available</p>
        </div>
      </div>

      {/* grid */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(310px,1fr))",gap:16}}>
        {items.map(p=>{
          const minP   = Math.min(...p.variants.map(v=>v.price));
          const maxD   = Math.max(...p.variants.map(v=>v.disc));
          const vCount = p.variants.length;
          return (
            <div key={p.id} onClick={()=>onSelect(p)}
              style={{background:"#141419",border:"0.5px solid #2A2A36",cursor:"pointer",transition:"all .3s",borderRadius:1,overflow:"hidden"}}
              onMouseEnter={e=>{e.currentTarget.style.borderColor="#C8102E";e.currentTarget.style.transform="translateY(-5px)";e.currentTarget.style.boxShadow="0 20px 56px rgba(0,0,0,.55),0 0 0 0.5px #C8102E";}}
              onMouseLeave={e=>{e.currentTarget.style.borderColor="#2A2A36";e.currentTarget.style.transform="translateY(0)";e.currentTarget.style.boxShadow="none";}}>
              {/* image */}
              <div style={{height:196,background:"#1E1E28",display:"flex",alignItems:"center",justifyContent:"center",fontSize:80,position:"relative"}}>
                {p.flash&&<div style={{position:"absolute",top:0,left:0,background:"#C8102E",color:"#fff",fontSize:8,fontWeight:700,padding:"3px 8px",letterSpacing:1}}>⚡ FLASH</div>}
                {p.pop&&<div style={{position:"absolute",top:p.flash?20:0,right:0,background:"#141419",border:"0.5px solid rgba(200,16,46,.3)",color:"#C8102E",fontSize:8,fontWeight:700,padding:"3px 8px",letterSpacing:1}}>⭐ POPULAR</div>}
                <div style={{position:"absolute",inset:0,background:"radial-gradient(circle at 50% 50%,rgba(200,16,46,.045) 0%,transparent 65%)"}}/>
                <span style={{opacity:.62,position:"relative",zIndex:1}}>{p.emoji}</span>
              </div>
              {/* body */}
              <div style={{padding:"20px 22px 24px"}}>
                <span className="tag-lbl" style={{marginBottom:5}}>{p.cat}</span>
                <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:20,color:"#FFFFFF",letterSpacing:.4,marginBottom:5,lineHeight:1.1}}>{p.name}</div>
                <p style={{fontSize:12,color:"#888897",marginBottom:14,fontStyle:"italic",lineHeight:1.5}}>{p.tagline}</p>
                {/* variant preview pills */}
                <div style={{display:"flex",flexWrap:"wrap",gap:5,marginBottom:18}}>
                  {p.variants.slice(0,4).map(v=>(
                    <span key={v.vid} style={{fontSize:9,color:"#888897",background:"#0C0C0F",border:"0.5px solid #2A2A36",padding:"2px 8px"}}>{v.label}</span>
                  ))}
                  {vCount>4&&<span style={{fontSize:9,color:"#C8102E",padding:"2px 6px"}}>+{vCount-4} more</span>}
                </div>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-end"}}>
                  <div>
                    <div style={{fontSize:10,color:"#888897",marginBottom:2}}>starting from</div>
                    <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:28,color:"#FFFFFF",letterSpacing:.5}}>{fmt(minP)}</div>
                    <div style={{display:"flex",alignItems:"center",gap:5,marginTop:3}}>
                      <Stars r={p.rating} sz={10}/>
                      <span style={{fontSize:10,color:"#444454"}}>({p.rev})</span>
                    </div>
                  </div>
                  <div style={{textAlign:"right"}}>
                    <div style={{background:"#C8102E",color:"#fff",fontSize:9,fontWeight:800,padding:"3px 8px",letterSpacing:.5,marginBottom:5}}>UP TO {maxD}% OFF</div>
                    <div style={{fontSize:10,color:"#888897"}}>{vCount} variants</div>
                  </div>
                </div>
                <button className="btn btn-r" style={{width:"100%",marginTop:16,padding:"10px",fontSize:9,letterSpacing:2.5}}>VIEW ALL VARIANTS \u2192</button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

/* ═══════════════════════════
   ADMIN — PRODUCTS
═══════════════════════════ */
function AProducts({products,setProducts,toast}){
  const [open,setOpen]=useState(null);
  const togPop   = id=>setProducts(p=>p.map(x=>x.id===id?{...x,pop:!x.pop}:x));
  const togFlash = id=>setProducts(p=>p.map(x=>x.id===id?{...x,flash:!x.flash}:x));
  const setStock = (pid,vid,val)=>setProducts(p=>p.map(x=>x.id===pid?{...x,variants:x.variants.map(v=>v.vid===vid?{...v,stock:+val}:v)}:x));
  const setPrice = (pid,vid,val)=>setProducts(p=>p.map(x=>x.id===pid?{...x,variants:x.variants.map(v=>v.vid===vid?{...v,price:+val}:v)}:x));
  const totalVariants = products.reduce((s,p)=>s+p.variants.length,0);
  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:24}}>
        <h2 className="disp" style={{fontSize:28,letterSpacing:1}}>PRODUCTS & VARIANTS
          <span style={{fontSize:13,color:"#888897",fontFamily:"'Inter',sans-serif",fontWeight:400,marginLeft:10}}>({products.length} products · {totalVariants} variants)</span>
        </h2>
      </div>
      <div style={{display:"flex",flexDirection:"column",gap:6}}>
        {products.map(p=>{
          const isOpen = open===p.id;
          const minP   = Math.min(...p.variants.map(v=>v.price));
          const totSt  = p.variants.reduce((s,v)=>s+v.stock,0);
          return (
            <div key={p.id} style={{background:"#141419",border:`0.5px solid ${isOpen?"#C8102E":"#2A2A36"}`,borderRadius:1,overflow:"hidden",transition:"border .2s"}}>
              <div style={{display:"flex",alignItems:"center",gap:14,padding:"14px 18px",cursor:"pointer"}} onClick={()=>setOpen(isOpen?null:p.id)}>
                <span style={{fontSize:26,flexShrink:0}}>{p.emoji}</span>
                <div style={{flex:1}}>
                  <div style={{fontWeight:600,fontSize:14,color:"#D4D4E0"}}>{p.name}</div>
                  <div style={{fontSize:11,color:"#888897",marginTop:2}}>{p.cat} &nbsp;·&nbsp; {p.variants.length} variants &nbsp;·&nbsp; from {fmt(minP)} &nbsp;·&nbsp; total stock: <span style={{color:totSt<5?"#C8102E":totSt<15?"#E6A817":"#22A65A",fontWeight:700}}>{totSt}</span></div>
                </div>
                <div style={{display:"flex",gap:8,alignItems:"center"}}>
                  <button onClick={e=>{e.stopPropagation();togPop(p.id);toast(p.pop?"Removed from popular":"Marked popular ✓");}}
                    style={{background:p.pop?"#C8102E":"#1E1E28",border:`0.5px solid ${p.pop?"#C8102E":"#2A2A36"}`,color:p.pop?"#fff":"#888897",padding:"4px 10px",cursor:"pointer",fontSize:9,fontWeight:700,letterSpacing:1,borderRadius:1}}>
                    {p.pop?"⭐ POPULAR":"SET POPULAR"}
                  </button>
                  <button onClick={e=>{e.stopPropagation();togFlash(p.id);toast(p.flash?"Flash off":"Flash enabled ✓");}}
                    style={{background:p.flash?"#C8102E":"#1E1E28",border:`0.5px solid ${p.flash?"#C8102E":"#2A2A36"}`,color:p.flash?"#fff":"#888897",padding:"4px 10px",cursor:"pointer",fontSize:9,fontWeight:700,letterSpacing:1,borderRadius:1}}>
                    {p.flash?"⚡ FLASH ON":"⚡ FLASH OFF"}
                  </button>
                  <span style={{color:"#888897",fontSize:14,display:"inline-block",transform:isOpen?"rotate(180deg)":"none",transition:"transform .2s"}}>▾</span>
                </div>
              </div>
              {isOpen&&(
                <div style={{borderTop:"0.5px solid #2A2A36"}}>
                  <div style={{overflowX:"auto"}}>
                  <table className="tbl">
                    <thead><tr><th>Variant</th><th>ID</th><th>Price ₹</th><th>MRP</th><th>Disc</th><th>Stock</th><th>Status</th></tr></thead>
                    <tbody>
                      {p.variants.map(v=>(
                        <tr key={v.vid}>
                          <td style={{fontWeight:600,color:"#D4D4E0"}}>{v.label}</td>
                          <td style={{fontSize:10,color:"#444454",fontFamily:"monospace"}}>{v.vid}</td>
                          <td>
                            <input type="number" value={v.price} onChange={e=>setPrice(p.id,v.vid,e.target.value)}
                              style={{background:"#0C0C0F",border:"0.5px solid #2A2A36",color:"#C8102E",width:90,padding:"5px 8px",fontFamily:"'Bebas Neue',sans-serif",fontSize:16,outline:"none",borderRadius:1}}
                              onFocus={e=>e.target.style.borderColor="#C8102E"} onBlur={e=>e.target.style.borderColor="#2A2A36"}/>
                          </td>
                          <td style={{fontSize:11,color:"#444454",textDecoration:"line-through"}}>{fmt(v.mrp)}</td>
                          <td><span style={{background:"rgba(200,16,46,.11)",color:"#C8102E",fontSize:10,fontWeight:700,padding:"2px 6px"}}>{v.disc}%</span></td>
                          <td>
                            <input type="number" value={v.stock} onChange={e=>setStock(p.id,v.vid,e.target.value)}
                              style={{background:"#0C0C0F",border:"0.5px solid #2A2A36",color:v.stock<5?"#C8102E":v.stock<10?"#E6A817":"#22A65A",width:70,padding:"5px 8px",fontSize:13,fontWeight:700,outline:"none",borderRadius:1,fontFamily:"'Inter',sans-serif"}}
                              onFocus={e=>e.target.style.borderColor="#C8102E"} onBlur={e=>e.target.style.borderColor="#2A2A36"}/>
                          </td>
                          <td><span style={{color:v.stock===0?"#C8102E":v.stock<5?"#E6A817":"#22A65A",fontSize:11,fontWeight:600}}>{v.stock===0?"Out of Stock":v.stock<5?"Low Stock":"In Stock"}</span></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

/* ── ADMIN FLASH ── */
function AFlash({products,setProducts,toast}){
  const [secs,setSecs]=useState(21600);
  const [hrs,setHrs]=useState("06");
  useEffect(()=>{const t=setInterval(()=>setSecs(s=>s>0?s-1:0),1000);return()=>clearInterval(t);},[]);
  const p2=n=>String(n).padStart(2,"0");
  const H=p2(Math.floor(secs/3600)),M=p2(Math.floor((secs%3600)/60)),S=p2(secs%60);
  const flashP=products.filter(p=>p.flash), otherP=products.filter(p=>!p.flash);
  const Tick=({v,l})=><div style={{background:"#C8102E",color:"#fff",padding:"9px 14px",minWidth:58,textAlign:"center",fontFamily:"'Bebas Neue',sans-serif",fontSize:26,letterSpacing:1,lineHeight:1}}>{v}<div style={{fontSize:8,fontFamily:"'Inter',sans-serif",letterSpacing:2,opacity:.8,marginTop:3}}>{l}</div></div>;
  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:24,flexWrap:"wrap",gap:12}}>
        <h2 className="disp" style={{fontSize:28,letterSpacing:1}}>FLASH SALES</h2>
        <div style={{display:"flex",gap:3}}><Tick v={H} l="HRS"/><Tick v={M} l="MIN"/><Tick v={S} l="SEC"/></div>
      </div>
      <div style={{background:"#141419",border:"0.5px solid rgba(200,16,46,.25)",padding:16,marginBottom:20,borderRadius:1,display:"flex",gap:10,alignItems:"center"}}>
        <input className="inp" type="number" style={{width:80}} value={hrs} onChange={e=>setHrs(e.target.value)}/>
        <span style={{fontSize:12,color:"#888897"}}>hours</span>
        <button className="btn btn-r btn-sm" onClick={()=>{setSecs((+hrs||1)*3600);toast("Timer set ✓");}}>SET TIMER</button>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:20}}>
        <div>
          <div style={{fontSize:9,color:"#C8102E",letterSpacing:2.5,textTransform:"uppercase",fontWeight:700,marginBottom:12}}>ACTIVE ({flashP.length})</div>
          {flashP.length===0&&<div style={{padding:30,textAlign:"center",color:"#444454",background:"#141419",border:"0.5px dashed #2A2A36",fontSize:12}}>No flash items active</div>}
          {flashP.map(p=>(
            <div key={p.id} style={{background:"#141419",border:"0.5px solid rgba(200,16,46,.22)",padding:"13px 16px",marginBottom:8,display:"flex",justifyContent:"space-between",alignItems:"center",borderRadius:1}}>
              <div>
                <div style={{fontSize:22,marginBottom:4}}>{p.emoji}</div>
                <div style={{fontWeight:600,fontSize:13,color:"#D4D4E0"}}>{p.name}</div>
                <div style={{fontSize:11,color:"#888897",marginTop:2}}>from {fmt(Math.min(...p.variants.map(v=>v.price)))} · {p.variants.length} variants</div>
              </div>
              <button onClick={()=>{setProducts(prev=>prev.map(x=>x.id===p.id?{...x,flash:false}:x));toast("Removed");}}
                style={{background:"rgba(200,16,46,.12)",border:"0.5px solid rgba(200,16,46,.3)",color:"#C8102E",padding:"6px 12px",cursor:"pointer",fontSize:9,fontWeight:700,letterSpacing:1.5,borderRadius:1}}>
                REMOVE
              </button>
            </div>
          ))}
        </div>
        <div>
          <div style={{fontSize:9,color:"#888897",letterSpacing:2.5,textTransform:"uppercase",fontWeight:700,marginBottom:12}}>ADD TO FLASH</div>
          {otherP.map(p=>(
            <div key={p.id} style={{background:"#141419",border:"0.5px solid #2A2A36",padding:"13px 16px",marginBottom:8,display:"flex",justifyContent:"space-between",alignItems:"center",borderRadius:1}}>
              <div>
                <div style={{fontSize:22,marginBottom:4}}>{p.emoji}</div>
                <div style={{fontWeight:600,fontSize:13,color:"#D4D4E0"}}>{p.name}</div>
                <div style={{fontSize:11,color:"#888897",marginTop:2}}>from {fmt(Math.min(...p.variants.map(v=>v.price)))}</div>
              </div>
              <button onClick={()=>{setProducts(prev=>prev.map(x=>x.id===p.id?{...x,flash:true}:x));toast("Added ✓");}}
                style={{background:"#1E1E28",border:"0.5px solid #2A2A36",color:"#D4D4E0",padding:"6px 12px",cursor:"pointer",fontSize:9,fontWeight:700,letterSpacing:1.5,borderRadius:1}}>
                ADD
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

/* ── ADMIN POPULAR ── */
function APopular({products,setProducts,toast}){
  const popP=products.filter(p=>p.pop);
  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:24}}>
        <h2 className="disp" style={{fontSize:28,letterSpacing:1}}>POPULAR PRODUCTS</h2>
        <span style={{fontSize:9,color:"#888897",letterSpacing:2.5,textTransform:"uppercase"}}>{popP.length} marked</span>
      </div>
      <div style={{background:"#141419",border:"0.5px solid #2A2A36",padding:16,marginBottom:20,display:"flex",flexWrap:"wrap",gap:8,minHeight:52,borderRadius:1}}>
        {popP.map(p=><span key={p.id} style={{background:"rgba(200,16,46,.11)",border:"0.5px solid rgba(200,16,46,.28)",color:"#C8102E",fontSize:10,fontWeight:700,padding:"4px 12px"}}>{p.emoji} {p.name}</span>)}
        {popP.length===0&&<span style={{color:"#444454",fontSize:12}}>None marked yet</span>}
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:10}}>
        {products.map(p=>(
          <div key={p.id} style={{background:"#141419",border:`0.5px solid ${p.pop?"rgba(200,16,46,.35)":"#2A2A36"}`,padding:"14px 18px",display:"flex",justifyContent:"space-between",alignItems:"center",borderRadius:1,transition:"border .2s"}}>
            <div style={{display:"flex",gap:12,alignItems:"center"}}>
              <span style={{fontSize:26}}>{p.emoji}</span>
              <div>
                <div style={{fontWeight:600,fontSize:13,color:"#D4D4E0"}}>{p.name}</div>
                <div style={{fontSize:10,color:"#888897",marginTop:2}}>{p.cat} · {p.variants.length} variants</div>
              </div>
            </div>
            <button onClick={()=>{setProducts(prev=>prev.map(x=>x.id===p.id?{...x,pop:!x.pop}:x));toast(p.pop?"Removed":"Marked popular ✓");}}
              className="btn btn-sm"
              style={{background:p.pop?"#C8102E":"#1E1E28",border:`0.5px solid ${p.pop?"#C8102E":"#2A2A36"}`,color:p.pop?"#fff":"#888897",borderRadius:1}}>
              {p.pop?"✓":"SET"}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ── ADMIN SEO ── */
function ASEO({seo,setSeo,toast}){
  const [f,setF]=useState({...seo});
  const up=(k,v)=>setF(x=>({...x,[k]:v}));
  const tOK=f.metaTitle.length<=60, dOK=f.metaDesc.length<=160;
  const Lbl=({c,count,max})=>(
    <label style={{fontSize:9,color:"#888897",marginBottom:4,display:"flex",justifyContent:"space-between",letterSpacing:2,textTransform:"uppercase"}}>
      <span>{c}</span>{count!==undefined&&<span style={{color:count>max?"#C8102E":"#22A65A",fontWeight:700}}>{count}/{max}</span>}
    </label>
  );
  const Panel=({title,children})=>(
    <div style={{background:"#141419",border:"0.5px solid #2A2A36",padding:22,marginBottom:14,borderRadius:1}}>
      <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:13,letterSpacing:3,color:"#C8102E",textTransform:"uppercase",marginBottom:18}}>{title}</div>
      {children}
    </div>
  );
  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:24}}>
        <h2 className="disp" style={{fontSize:28,letterSpacing:1}}>SEO MANAGER</h2>
        <button className="btn btn-r" onClick={()=>{setSeo(f);toast("SEO saved ✓");}}>SAVE ALL CHANGES</button>
      </div>
      <Panel title="Meta Tags">
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          <div><Lbl c="Meta Title" count={f.metaTitle.length} max={60}/><input className="inp" value={f.metaTitle} onChange={e=>up("metaTitle",e.target.value)}/></div>
          <div><Lbl c="Meta Description" count={f.metaDesc.length} max={160}/><textarea className="inp" value={f.metaDesc} onChange={e=>up("metaDesc",e.target.value)} rows={3}/></div>
          <div><Lbl c="Keywords"/><input className="inp" value={f.metaKw} onChange={e=>up("metaKw",e.target.value)}/></div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
            <div><Lbl c="Canonical URL"/><input className="inp" value={f.canonical} onChange={e=>up("canonical",e.target.value)}/></div>
            <div><Lbl c="Robots"/><select className="inp" value={f.robots} onChange={e=>up("robots",e.target.value)}><option>index, follow</option><option>noindex, nofollow</option><option>index, nofollow</option></select></div>
          </div>
        </div>
      </Panel>
      <Panel title="Open Graph — Social Sharing">
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          <div><Lbl c="OG Title"/><input className="inp" value={f.ogTitle} onChange={e=>up("ogTitle",e.target.value)}/></div>
          <div><Lbl c="OG Description"/><textarea className="inp" value={f.ogDesc} onChange={e=>up("ogDesc",e.target.value)} rows={2}/></div>
          <div><Lbl c="OG Image URL"/><input className="inp" value={f.ogImg} onChange={e=>up("ogImg",e.target.value)}/></div>
        </div>
      </Panel>
      <Panel title="JSON-LD Structured Data">
        <textarea className="inp" value={f.schema} onChange={e=>up("schema",e.target.value)} rows={10} style={{fontFamily:"monospace",fontSize:12,lineHeight:1.65}}/>
        <button onClick={()=>{try{JSON.parse(f.schema);toast("Valid JSON ✓");}catch{toast("❌ Invalid JSON");}}} style={{marginTop:10,background:"#1E1E28",border:"0.5px solid #2A2A36",color:"#D4D4E0",padding:"7px 14px",cursor:"pointer",fontSize:9,fontFamily:"'Inter',sans-serif",fontWeight:700,letterSpacing:2,borderRadius:1}}>VALIDATE JSON</button>
      </Panel>
      <Panel title="Google Search Preview">
        <div style={{background:"#fff",padding:"20px 24px",borderRadius:3}}>
          <div style={{color:"#1a0dab",fontSize:20,fontFamily:"Arial,sans-serif"}}>{f.metaTitle}</div>
          <div style={{color:"#006621",fontSize:13,fontFamily:"Arial,sans-serif",margin:"3px 0"}}>{f.canonical}</div>
          <div style={{color:"#545454",fontSize:14,fontFamily:"Arial,sans-serif",lineHeight:1.58}}>{f.metaDesc}</div>
        </div>
      </Panel>
    </div>
  );
}

/* ── ADMIN SHELL ── */
function Admin({products,setProducts,seo,setSeo,onBack}){
  const [tab,setTab]=useState("products");
  const [msg,setMsg]=useState(null);
  const NAV=[{id:"products",icon:"📦",label:"Products & Variants"},{id:"flash",icon:"⚡",label:"Flash Sales"},{id:"popular",icon:"⭐",label:"Popular"},{id:"seo",icon:"🔍",label:"SEO"}];
  return (
    <div style={{display:"flex",minHeight:"100vh",background:"#0C0C0F",color:"#D4D4E0",fontFamily:"'Inter',sans-serif"}}>
      <style>{CSS}</style>
      <div style={{width:228,background:"#141419",borderRight:"0.5px solid #2A2A36",display:"flex",flexDirection:"column",flexShrink:0}}>
        <div style={{padding:"22px 20px 18px",borderBottom:"0.5px solid #2A2A36"}}><Logo size={22}/><div style={{fontSize:9,color:"#888897",letterSpacing:3,marginTop:3,textTransform:"uppercase"}}>Admin Console</div></div>
        <button onClick={onBack} style={{margin:"12px 14px 4px",background:"#1E1E28",border:"0.5px solid #2A2A36",color:"#888897",padding:"8px 14px",cursor:"pointer",fontSize:9,fontFamily:"'Inter',sans-serif",fontWeight:700,letterSpacing:2,textTransform:"uppercase",textAlign:"left",borderRadius:1}}>← BACK TO SITE</button>
        <nav style={{flex:1,paddingTop:4}}>
          {NAV.map(n=><div key={n.id} className={`anav${tab===n.id?" act":""}`} onClick={()=>setTab(n.id)}><span>{n.icon}</span>{n.label}</div>)}
        </nav>
        <div style={{padding:16,borderTop:"0.5px solid #2A2A36",lineHeight:2.1}}>
          {[["Products",products.length,"#D4D4E0"],["Total Variants",products.reduce((s,p)=>s+p.variants.length,0),"#D4D4E0"],["Flash Active",products.filter(p=>p.flash).length,"#C8102E"],["Popular",products.filter(p=>p.pop).length,"#888897"]].map(([l,v,c])=>(
            <div key={l} style={{display:"flex",justifyContent:"space-between",fontSize:11}}><span style={{color:"#888897"}}>{l}</span><strong style={{color:c}}>{v}</strong></div>
          ))}
        </div>
      </div>
      <div style={{flex:1,padding:"36px 40px",overflow:"auto"}}>
        {tab==="products"&&<AProducts products={products} setProducts={setProducts} toast={setMsg}/>}
        {tab==="flash"&&<AFlash products={products} setProducts={setProducts} toast={setMsg}/>}
        {tab==="popular"&&<APopular products={products} setProducts={setProducts} toast={setMsg}/>}
        {tab==="seo"&&<ASEO seo={seo} setSeo={setSeo} toast={setMsg}/>}
      </div>
      {msg&&<Toast msg={msg} onClose={()=>setMsg(null)}/>}
    </div>
  );
}

/* ═══════════════════════════
   MAIN APP
═══════════════════════════ */
export default function LYFYHomes(){
  const [view,setView]             = useState("home");
  const [activeCat,setActiveCat]   = useState(null);
  const [activeProd,setActiveProd] = useState(null);
  const [products,setProducts]     = useState(PRODUCTS);
  const [seo,setSeo]               = useState(INIT_SEO);
  const [slide,setSlide]           = useState(0);
  const [cart,setCart]             = useState([]);
  const [cartOpen,setCartOpen]     = useState(false);
  const [wishlist,setWishlist]     = useState([]);
  const [toast,setToast]           = useState(null);
  const [scrolled,setScrolled]     = useState(false);

  useEffect(()=>{const t=setInterval(()=>setSlide(s=>(s+1)%HERO.length),5600);return()=>clearInterval(t);},[]);
  useEffect(()=>{const fn=()=>setScrolled(window.scrollY>56);window.addEventListener("scroll",fn);return()=>window.removeEventListener("scroll",fn);},[]);

  const addCart=p=>{
    setCart(prev=>{const key=p.id+(p.variantLabel||"");const e=prev.find(i=>i._key===key);return e?prev.map(i=>i._key===key?{...i,qty:i.qty+1}:i):[...prev,{...p,_key:key,qty:1}];});
    setToast(`${p.name.slice(0,24)}… added!`);
  };
  const togWish=id=>setWishlist(prev=>prev.includes(id)?prev.filter(i=>i!==id):[...prev,id]);
  const cartCount=cart.reduce((s,i)=>s+i.qty,0);
  const cartTotal=cart.reduce((s,i)=>s+i.price*i.qty,0);
  const flashP=products.filter(p=>p.flash);
  const popP  =products.filter(p=>p.pop);

  const goCat  =cat =>{setActiveCat(cat);setView("cat");   window.scrollTo(0,0);};
  const goProd =p   =>{setActiveProd(p);setView("product");window.scrollTo(0,0);};
  const goHome =()  =>{setView("home");setActiveCat(null);setActiveProd(null);window.scrollTo(0,0);};
  const goCatBack=()=>{setView("cat");window.scrollTo(0,0);};

  if(view==="admin") return <Admin products={products} setProducts={setProducts} seo={seo} setSeo={setSeo} onBack={goHome}/>;

  /* shared header */
  const Header=()=>(
    <header style={{background:scrolled?"rgba(12,12,15,.97)":"transparent",borderBottom:scrolled?"0.5px solid #2A2A36":"0.5px solid transparent",position:"sticky",top:0,zIndex:100,transition:"all .35s",backdropFilter:"blur(16px)",WebkitBackdropFilter:"blur(16px)"}}>
      <div style={{borderBottom:"0.5px solid rgba(42,42,54,.4)",padding:"4px 56px",display:"flex",justifyContent:"flex-end",gap:22}}>
        {["About","Blog","Contact","Service & Support"].map(l=>(
          <a key={l} href="#" style={{color:"#444454",textDecoration:"none",fontSize:10,letterSpacing:.4,transition:"color .2s"}} onMouseEnter={e=>e.target.style.color="#C8102E"} onMouseLeave={e=>e.target.style.color="#444454"}>{l}</a>
        ))}
      </div>
      <div style={{padding:"12px 56px",display:"flex",alignItems:"center",gap:16}}>
        <div style={{cursor:"pointer"}} onClick={goHome}><Logo size={24}/></div>
        <nav style={{display:"flex",gap:2,marginLeft:28}}>
          {CATS.map(c=>(
            <a key={c.name} href="#" onClick={e=>{e.preventDefault();goCat(c.name);}}
              style={{padding:"7px 16px",color:activeCat===c.name?"#C8102E":"#888897",textDecoration:"none",fontSize:11,fontWeight:500,letterSpacing:.4,transition:"all .2s",borderBottom:`1.5px solid ${activeCat===c.name?"#C8102E":"transparent"}`,whiteSpace:"nowrap"}}
              onMouseEnter={e=>e.currentTarget.style.color="#FFFFFF"} onMouseLeave={e=>e.currentTarget.style.color=activeCat===c.name?"#C8102E":"#888897"}>
              {c.icon} {c.name}
            </a>
          ))}
        </nav>
        <div style={{flex:1,maxWidth:270,position:"relative"}}>
          <input placeholder="Search LYFY Homes…" style={{width:"100%",background:"rgba(30,30,40,.6)",border:"0.5px solid #2A2A36",borderRadius:1,padding:"8px 14px 8px 32px",color:"#D4D4E0",fontFamily:"'Inter',sans-serif",fontSize:12,outline:"none",transition:"border .2s"}} onFocus={e=>e.target.style.borderColor="#C8102E"} onBlur={e=>e.target.style.borderColor="#2A2A36"}/>
          <span style={{position:"absolute",left:9,top:"50%",transform:"translateY(-50%)",color:"#444454",fontSize:13}}>🔍</span>
        </div>
        <div style={{display:"flex",gap:4,alignItems:"center"}}>
          <button style={{background:"none",border:"none",color:"#888897",cursor:"pointer",fontSize:10,display:"flex",flexDirection:"column",alignItems:"center",gap:1,fontFamily:"'Inter',sans-serif",padding:"4px 7px"}}><span style={{fontSize:17}}>♡</span><span>{wishlist.length>0?`(${wishlist.length})`:"Wish"}</span></button>
          <button onClick={()=>setCartOpen(true)} className="btn btn-r" style={{fontSize:9,letterSpacing:2,padding:"9px 18px",gap:7}}>
            🛒 BAG {cartCount>0&&<span style={{background:"#8B0000",color:"#fff",borderRadius:"50%",width:17,height:17,fontSize:9,fontWeight:800,display:"inline-flex",alignItems:"center",justifyContent:"center"}}>{cartCount}</span>}
          </button>
          <button onClick={()=>setView("admin")} style={{background:"rgba(30,30,40,.6)",border:"0.5px solid #2A2A36",color:"#888897",padding:"9px 10px",borderRadius:1,cursor:"pointer",fontSize:12,transition:"border .2s"}} onMouseEnter={e=>e.currentTarget.style.borderColor="#C8102E"} onMouseLeave={e=>e.currentTarget.style.borderColor="#2A2A36"}>⚙️</button>
        </div>
      </div>
    </header>
  );

  /* cart drawer */
  const CartDrawer=()=>cartOpen?(
    <div style={{position:"fixed",inset:0,zIndex:200}}>
      <div style={{position:"absolute",inset:0,background:"rgba(12,12,15,.82)"}} onClick={()=>setCartOpen(false)}/>
      <div style={{position:"absolute",right:0,top:0,bottom:0,width:400,background:"#141419",borderLeft:"0.5px solid #2A2A36",display:"flex",flexDirection:"column",animation:"slideR .3s ease"}}>
        <div style={{padding:"20px 24px",borderBottom:"0.5px solid #2A2A36",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:22,letterSpacing:1,color:"#FFFFFF"}}>YOUR BAG <span style={{fontSize:14,color:"#888897",fontFamily:"'Inter',sans-serif"}}>({cartCount})</span></div>
          <button onClick={()=>setCartOpen(false)} style={{background:"none",border:"none",color:"#888897",cursor:"pointer",fontSize:20,lineHeight:1}}>✕</button>
        </div>
        <div style={{flex:1,overflow:"auto",padding:"16px 24px"}}>
          {cart.length===0?(
            <div style={{textAlign:"center",padding:"52px 20px",color:"#888897"}}>
              <div style={{fontSize:50,marginBottom:14}}>🛒</div>
              <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:18,letterSpacing:1}}>YOUR BAG IS EMPTY</div>
              <button onClick={()=>setCartOpen(false)} className="btn btn-o" style={{marginTop:18,fontSize:9}}>BROWSE PRODUCTS</button>
            </div>
          ):cart.map(item=>(
            <div key={item._key} style={{display:"flex",gap:14,padding:"13px 0",borderBottom:"0.5px solid #2A2A36"}}>
              <div style={{width:60,height:60,background:"#1E1E28",display:"flex",alignItems:"center",justifyContent:"center",fontSize:26,flexShrink:0,borderRadius:1}}>{item.emoji||"📦"}</div>
              <div style={{flex:1}}>
                <div style={{fontSize:13,fontWeight:600,color:"#D4D4E0",lineHeight:1.35}}>{item.name}</div>
                {item.variantLabel&&<div style={{fontSize:11,color:"#888897",marginTop:2}}>{item.variantLabel}</div>}
                <div style={{display:"flex",justifyContent:"space-between",marginTop:6}}>
                  <span style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:18,color:"#C8102E",letterSpacing:.5}}>{fmt(item.price)}</span>
                  <span style={{fontSize:11,color:"#888897"}}>× {item.qty}</span>
                </div>
              </div>
              <button onClick={()=>setCart(prev=>prev.filter(i=>i._key!==item._key))} style={{background:"none",border:"none",color:"#444454",cursor:"pointer",fontSize:16,alignSelf:"flex-start",lineHeight:1}}>✕</button>
            </div>
          ))}
        </div>
        {cart.length>0&&(
          <div style={{padding:"20px 24px",borderTop:"0.5px solid #2A2A36"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",marginBottom:16}}>
              <span style={{fontSize:9,color:"#888897",letterSpacing:2.5,textTransform:"uppercase"}}>Total</span>
              <span style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:30,color:"#FFFFFF",letterSpacing:.5}}>{fmt(cartTotal)}</span>
            </div>
            <button className="btn btn-r" style={{width:"100%",padding:13,fontSize:9,letterSpacing:2.5}}>CHECKOUT →</button>
            <button onClick={()=>setCart([])} style={{width:"100%",marginTop:9,background:"none",border:"none",color:"#444454",cursor:"pointer",fontSize:10,fontFamily:"'Inter',sans-serif"}}>Clear bag</button>
          </div>
        )}
      </div>
    </div>
  ):null;

  const FAB=()=>(
    <button onClick={()=>setView("admin")} style={{position:"fixed",bottom:26,right:26,background:"#C8102E",border:"none",width:44,height:44,color:"#fff",cursor:"pointer",fontSize:18,boxShadow:"0 4px 20px rgba(200,16,46,.5)",zIndex:50,display:"flex",alignItems:"center",justifyContent:"center",borderRadius:1,transition:"background .2s"}} onMouseEnter={e=>e.currentTarget.style.background="#E31837"} onMouseLeave={e=>e.currentTarget.style.background="#C8102E"}>⚙️</button>
  );

  /* ── CATEGORY VIEW ── */
  if(view==="cat") return (
    <>
      <style>{CSS}</style>
      <div style={{background:"#0C0C0F",minHeight:"100vh"}}>
        <Ticker/><Header/><CartDrawer/>
        <CatPage catName={activeCat} products={products} onSelect={goProd} onBack={goHome}/>
        <FAB/>
        {toast&&<Toast msg={toast} onClose={()=>setToast(null)}/>}
      </div>
    </>
  );

  /* ── PRODUCT VIEW ── */
  if(view==="product") return (
    <>
      <style>{CSS}</style>
      <div style={{background:"#0C0C0F",minHeight:"100vh"}}>
        <Ticker/><Header/><CartDrawer/>
        <ProductDetail product={activeProd} onBack={goCatBack} onAdd={addCart} onWish={togWish} wishlist={wishlist}/>
        {/* related */}
        <div style={{padding:"0 56px 80px",maxWidth:1440,margin:"0 auto"}}>
          <div className="hr" style={{marginBottom:52}}/>
          <span className="tag-lbl" style={{marginBottom:8}}>Same Range</span>
          <h3 className="disp" style={{fontSize:34,marginBottom:28}}>MORE {activeProd.cat.toUpperCase()}S</h3>
          <div className="srow">
            {products.filter(p=>p.cat===activeProd.cat&&p.id!==activeProd.id).map(p=>{
              const minP=Math.min(...p.variants.map(v=>v.price));
              return (
                <div key={p.id} onClick={()=>goProd(p)} style={{background:"#141419",border:"0.5px solid #2A2A36",cursor:"pointer",borderRadius:1,overflow:"hidden",minWidth:230,maxWidth:230,flexShrink:0,transition:"all .3s"}}
                  onMouseEnter={e=>{e.currentTarget.style.borderColor="#C8102E";e.currentTarget.style.transform="translateY(-5px)";}}
                  onMouseLeave={e=>{e.currentTarget.style.borderColor="#2A2A36";e.currentTarget.style.transform="translateY(0)";}}>
                  <div style={{height:150,background:"#1E1E28",display:"flex",alignItems:"center",justifyContent:"center",fontSize:60}}><span style={{opacity:.65}}>{p.emoji}</span></div>
                  <div style={{padding:"14px 16px 18px"}}>
                    <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:17,color:"#FFFFFF",letterSpacing:.4,marginBottom:4,lineHeight:1.1}}>{p.name}</div>
                    <div style={{fontSize:10,color:"#888897",marginBottom:8}}>{p.variants.length} variants available</div>
                    <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:22,color:"#FFFFFF",letterSpacing:.5}}>{fmt(minP)}</div>
                    <div style={{fontSize:9,color:"#888897",marginTop:2}}>starting from</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <FAB/>
        {toast&&<Toast msg={toast} onClose={()=>setToast(null)}/>}
      </div>
    </>
  );

  /* ══════════════════════════════════════
     HOME PAGE
  ══════════════════════════════════════ */
  const sl=HERO[slide];
  return (
    <>
      <style>{CSS}</style>
      <Ticker/>
      <Header/>
      <CartDrawer/>

      {/* HERO */}
      <section style={{height:"90vh",minHeight:560,position:"relative",overflow:"hidden",background:"#0C0C0F"}}>
        <div style={{position:"absolute",inset:0,backgroundImage:"linear-gradient(rgba(42,42,54,.14) 1px,transparent 1px),linear-gradient(90deg,rgba(42,42,54,.14) 1px,transparent 1px)",backgroundSize:"72px 72px",pointerEvents:"none"}}/>
        {HERO.map((s,i)=>(
          <div key={i} style={{position:"absolute",inset:0,opacity:i===slide?1:0,transition:"opacity 1.1s ease",pointerEvents:i===slide?"auto":"none",zIndex:1}}>
            <div style={{position:"absolute",inset:0,background:"radial-gradient(ellipse 70% 90% at 78% 50%,rgba(200,16,46,.05) 0%,transparent 65%)"}}/>
            <div style={{height:"100%",display:"flex",alignItems:"center",padding:"0 56px",maxWidth:1440,margin:"0 auto",position:"relative",zIndex:2}}>
              <div style={{flex:1,maxWidth:640}}>
                <span className="tag-lbl" style={{color:"#888897",animation:i===slide?"fadeUp .5s .08s both":"none"}}>{s.sub}</span>
                <h1 className="disp" style={{fontSize:"clamp(74px,10vw,118px)",marginBottom:28,animation:i===slide?"fadeUp .55s .18s both":"none"}}>
                  <span style={{color:"#C8102E",display:"block"}}>{s.t1}</span>
                  <span style={{color:"#FFFFFF",display:"block"}}>{s.t2}</span>
                </h1>
                <p className="body-p" style={{fontSize:15,maxWidth:480,marginBottom:40,animation:i===slide?"fadeUp .55s .3s both":"none"}}>{s.body}</p>
                <div style={{display:"flex",gap:12,animation:i===slide?"fadeUp .55s .42s both":"none"}}>
                  <button className="btn btn-r" style={{padding:"13px 38px",fontSize:10,letterSpacing:2.5}}
                    onClick={()=>{if(i>0)goCat(["Chimney","Stove","Mixer Grinder"][i-1]);}}>{s.cta} →</button>
                  <button className="btn btn-o" style={{padding:"13px 26px",fontSize:10,letterSpacing:2.5}}>ALL PRODUCTS</button>
                </div>
              </div>
              <div style={{fontSize:"clamp(180px,28vw,320px)",opacity:.054,userSelect:"none",marginLeft:"auto",lineHeight:1}}>{s.emoji}</div>
            </div>
          </div>
        ))}
        <div style={{position:"absolute",bottom:38,left:56,display:"flex",gap:8,alignItems:"center",zIndex:10}}>
          {HERO.map((_,i)=>(
            <button key={i} onClick={()=>setSlide(i)} style={{width:i===slide?34:14,height:2,background:i===slide?"#C8102E":"rgba(42,42,54,.9)",border:"none",cursor:"pointer",transition:"all .35s",borderRadius:1}}/>
          ))}
          <span style={{color:"#444454",fontSize:10,letterSpacing:3,marginLeft:12}}>{String(slide+1).padStart(2,"0")} / {String(HERO.length).padStart(2,"0")}</span>
        </div>
      </section>

      {/* FLASH BAR */}
      {flashP.length>0&&(
        <div style={{background:"#0A0003",borderTop:"0.5px solid #8B0000",borderBottom:"0.5px solid #8B0000"}}>
          <div style={{maxWidth:1440,margin:"0 auto",padding:"12px 56px",display:"flex",alignItems:"center",gap:16}}>
            <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:15,color:"#C8102E",letterSpacing:3,flexShrink:0,animation:"pulse 2s infinite"}}>⚡ FLASH SALE</div>
            <div style={{flex:1,overflow:"hidden"}}>
              <div className="srow" style={{paddingBottom:0}}>
                {flashP.map(p=>(
                  <div key={p.id} onClick={()=>goProd(p)} style={{display:"flex",alignItems:"center",gap:10,border:"0.5px solid rgba(200,16,46,.22)",padding:"5px 14px",whiteSpace:"nowrap",flexShrink:0,cursor:"pointer"}}>
                    <span style={{fontSize:14}}>{p.emoji}</span>
                    <span style={{fontSize:12,color:"#D4D4E0",fontWeight:500}}>{p.name}</span>
                    <span style={{background:"#C8102E",color:"#fff",fontSize:9,fontWeight:800,padding:"2px 6px"}}>UP TO {Math.max(...p.variants.map(v=>v.disc))}% OFF</span>
                    <span style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:15,color:"#C8102E",letterSpacing:.5}}>from {fmt(Math.min(...p.variants.map(v=>v.price)))}</span>
                  </div>
                ))}
              </div>
            </div>
            <button className="btn btn-r btn-sm" style={{flexShrink:0}}>SHOP NOW →</button>
          </div>
        </div>
      )}

      {/* 3 CATEGORY BLOCKS */}
      <section style={{padding:"96px 56px"}}>
        <div style={{maxWidth:1440,margin:"0 auto"}}>
          <div style={{textAlign:"center",marginBottom:56}}>
            <span className="tag-lbl" style={{textAlign:"center",display:"block",marginBottom:10}}>Our Range</span>
            <h2 className="disp" style={{fontSize:58}}>SHOP BY <span style={{color:"#C8102E"}}>CATEGORY</span></h2>
            <p className="body-p" style={{marginTop:14,maxWidth:520,margin:"14px auto 0"}}>Three categories, engineered to work together — giving every Indian kitchen the performance, style and reliability it deserves.</p>
          </div>
          <div className="seam" style={{gridTemplateColumns:"repeat(3,1fr)"}}>
            {CATS.map(cat=>{
              const catProds=products.filter(p=>p.cat===cat.name);
              const totalV=catProds.reduce((s,p)=>s+p.variants.length,0);
              const minP=Math.min(...catProds.flatMap(p=>p.variants.map(v=>v.price)));
              return (
                <div key={cat.name} className="seam-c" onClick={()=>goCat(cat.name)} style={{padding:"52px 48px",cursor:"pointer",position:"relative",overflow:"hidden"}}>
                  <div style={{position:"absolute",right:-12,bottom:-12,fontSize:110,opacity:.04,lineHeight:1,userSelect:"none"}}>{cat.icon}</div>
                  <div style={{fontSize:48,marginBottom:22}}>{cat.icon}</div>
                  <span className="tag-lbl" style={{marginBottom:6,color:"#444454"}}>{cat.sub}</span>
                  <div className="disp" style={{fontSize:28,marginBottom:8}}>{cat.name.toUpperCase()}</div>
                  <p className="body-p" style={{fontSize:13,marginBottom:18}}>{cat.hero}</p>
                  <div style={{fontSize:12,color:"#888897",marginBottom:22}}>{catProds.length} products · {totalV} variants · from {fmt(minP)}</div>
                  <div style={{display:"flex",alignItems:"center",gap:8}}>
                    <div style={{width:18,height:.5,background:"#C8102E"}}/>
                    <span style={{fontSize:9,color:"#C8102E",fontWeight:700,letterSpacing:2.5,textTransform:"uppercase"}}>EXPLORE ALL →</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <div className="hr"/>

      {/* POPULAR */}
      {popP.length>0&&(
        <section style={{padding:"96px 56px",background:"#141419"}}>
          <div style={{maxWidth:1440,margin:"0 auto"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-end",marginBottom:48}}>
              <div>
                <span className="tag-lbl">Staff Picks</span>
                <h2 className="disp" style={{fontSize:54}}>MOST POPULAR</h2>
                <p className="body-p" style={{marginTop:10,maxWidth:440}}>Chosen by thousands of Indian homes — products our customers love most.</p>
              </div>
            </div>
            <div className="srow">
              {popP.map(p=>{
                const minP=Math.min(...p.variants.map(v=>v.price));
                const maxD=Math.max(...p.variants.map(v=>v.disc));
                return (
                  <div key={p.id} onClick={()=>goProd(p)} style={{background:"#0C0C0F",border:"0.5px solid #2A2A36",cursor:"pointer",transition:"all .3s",borderRadius:1,overflow:"hidden",minWidth:236,maxWidth:236,flexShrink:0}}
                    onMouseEnter={e=>{e.currentTarget.style.borderColor="#C8102E";e.currentTarget.style.transform="translateY(-6px)";e.currentTarget.style.boxShadow="0 20px 56px rgba(0,0,0,.55)";}}
                    onMouseLeave={e=>{e.currentTarget.style.borderColor="#2A2A36";e.currentTarget.style.transform="translateY(0)";e.currentTarget.style.boxShadow="none";}}>
                    <div style={{height:176,background:"#1E1E28",display:"flex",alignItems:"center",justifyContent:"center",fontSize:72,position:"relative"}}>
                      {p.flash&&<div style={{position:"absolute",top:0,left:0,background:"#C8102E",color:"#fff",fontSize:8,fontWeight:700,padding:"3px 8px",letterSpacing:1}}>⚡ FLASH</div>}
                      <span style={{opacity:.64}}>{p.emoji}</span>
                    </div>
                    <div style={{padding:"16px 18px 20px"}}>
                      <span className="tag-lbl" style={{marginBottom:4,fontSize:8}}>{p.cat}</span>
                      <div className="disp" style={{fontSize:17,marginBottom:6,letterSpacing:.4,lineHeight:1.1}}>{p.name}</div>
                      <div style={{display:"flex",gap:4,flexWrap:"wrap",marginBottom:10}}>
                        {p.variants.slice(0,3).map(v=><span key={v.vid} style={{fontSize:8,color:"#888897",background:"#0C0C0F",border:"0.5px solid #2A2A36",padding:"2px 6px"}}>{v.label}</span>)}
                        {p.variants.length>3&&<span style={{fontSize:8,color:"#C8102E"}}>+{p.variants.length-3}</span>}
                      </div>
                      <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:24,color:"#FFFFFF",letterSpacing:.5}}>{fmt(minP)}</div>
                      <div style={{fontSize:9,color:"#888897",marginTop:2,marginBottom:12}}>from · up to {maxD}% off</div>
                      <button className="btn btn-r" style={{width:"100%",padding:"8px",fontSize:9,letterSpacing:2}}>VIEW VARIANTS →</button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      )}

      <div className="hr"/>

      {/* FOOTER */}
      <footer style={{background:"#141419",borderTop:"0.5px solid #2A2A36"}}>
        <div style={{borderBottom:"0.5px solid #2A2A36"}}>
          <div style={{maxWidth:1440,margin:"0 auto",padding:"60px 56px",display:"flex",alignItems:"center",gap:80,flexWrap:"wrap"}}>
            <div style={{minWidth:260}}>
              <span className="tag-lbl">Newsletter</span>
              <h3 className="disp" style={{fontSize:44}}>STAY IN<br/><span style={{color:"#C8102E"}}>THE LOOP</span></h3>
            </div>
            <div style={{flex:1,minWidth:260}}>
              <p className="body-p" style={{marginBottom:20}}>Latest deals, new products and kitchen tips — straight to your inbox.</p>
              <div style={{display:"flex"}}>
                <input placeholder="Enter your email address" style={{flex:1,background:"#0C0C0F",border:"0.5px solid #2A2A36",borderRight:"none",color:"#D4D4E0",padding:"12px 16px",fontFamily:"'Inter',sans-serif",fontSize:13,outline:"none",transition:"border .2s",borderRadius:0}} onFocus={e=>e.target.style.borderColor="#C8102E"} onBlur={e=>e.target.style.borderColor="#2A2A36"}/>
                <button className="btn btn-r" style={{fontSize:9,letterSpacing:2.5,padding:"12px 20px",borderRadius:0}} onClick={()=>setToast("Subscribed! 🎉")}>SUBSCRIBE</button>
              </div>
            </div>
          </div>
        </div>
        <div style={{maxWidth:1440,margin:"0 auto",padding:"56px 56px",display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr",gap:48}}>
          <div>
            <Logo size={22}/>
            <p className="body-p" style={{marginTop:18,marginBottom:24,maxWidth:300,lineHeight:1.88}}>Premium chimneys, stoves and mixer grinders — engineered for the modern Indian kitchen since 1994.</p>
            <div style={{display:"flex",gap:8}}>
              {["📘","📸","▶️","🐦"].map((ic,i)=>(
                <a key={i} href="#" style={{width:32,height:32,border:"0.5px solid #2A2A36",display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,textDecoration:"none",transition:"border .2s",borderRadius:1}} onMouseEnter={e=>e.currentTarget.style.borderColor="#C8102E"} onMouseLeave={e=>e.currentTarget.style.borderColor="#2A2A36"}>{ic}</a>
              ))}
            </div>
          </div>
          {[
            {title:"Products",  links:["Chimneys","Stoves & Hobs","Mixer Grinders"]},
            {title:"Discover",  links:["About LYFY Homes","Awards","Blog","FAQs","Contact Us","Track Order"]},
            {title:"Legal",     links:["Terms & Conditions","Privacy Policy","Refund Policy","Shipping Policy","E-Waste Policy"]},
          ].map(col=>(
            <div key={col.title}>
              <div style={{fontSize:9,fontWeight:700,letterSpacing:3,textTransform:"uppercase",color:"#D4D4E0",marginBottom:18}}>{col.title}</div>
              <div style={{display:"flex",flexDirection:"column",gap:12}}>
                {col.links.map(l=><a key={l} href="#" style={{color:"#888897",textDecoration:"none",fontSize:13,transition:"color .2s"}} onMouseEnter={e=>e.target.style.color="#C8102E"} onMouseLeave={e=>e.target.style.color="#888897"}>{l}</a>)}
              </div>
            </div>
          ))}
        </div>
        <div style={{borderTop:"0.5px solid #2A2A36"}}>
          <div style={{maxWidth:1440,margin:"0 auto",padding:"16px 56px",display:"flex",justifyContent:"space-between",flexWrap:"wrap",gap:8}}>
            <span style={{fontSize:10,color:"#444454"}}>© LYFY Homes 2026. All rights reserved.</span>
            <span style={{fontSize:10,color:"#444454"}}>Engineered for India ❤️</span>
          </div>
        </div>
      </footer>

      <FAB/>
      {toast&&<Toast msg={toast} onClose={()=>setToast(null)}/>}
    </>
  );
}
